<template>
    <div>
        <img class="thumbnail" :src="src" @click="switchImage">
        <div class="overlay" v-show="fullscreen" @click="switchImage">
            <img :src="src">
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            src: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                fullscreen: false
            }
        },

        methods: {
            switchImage() {
                this.fullscreen = !this.fullscreen
            },
        }
    }
</script>

<style scoped>

    .thumbnail {
        max-width: 100%;
        cursor: pointer;
    }
    
    .overlay {
        position: fixed;
        z-index: 1100;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: white;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    
    .overlay img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        cursor: pointer;
    }

</style>
